import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Education (to be removed)", "Образование (будет удалено)."][index],
        subtitle: [
            "This section will be removed soon. Please use the one above.",
            "Этот раздел скоро уберут. Используйте раздел выше.",
        ][index],
        addEducation: ["Add Education", "Добавить Образование"][index],
        placeholder: [
            "Educational Institution, Specialization, Degree",
            "Учебное заведение, специальность, степень",
        ][index],
        validationMessage: ["Graduation year might be omitted", "Год выпуска может быть опущен"][index],
    };
};
